module.exports = __webpack_public_path__ + "static/media/Giovanna-Stenner_1654200183384.d394d615.png";